module.exports = __webpack_public_path__ + "img/SMOLENSK.8b79d705.png";